// Third Party Imports
import React from 'react';

// HA Artifactory Imports
import FormSelect from '@homeaway/react-form-select';

// Relative Imports
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import AlertBox from '../Alert/Alert';
import './PayoutDetails.less';
import getCurrencySymbol from '../utils/currencyUtil';
import InfoCard from '../Card/InfoCard';
import StabAddressFormConfigurator from '@homeaway/stab-address-form-configurator';
import {toArray} from 'lodash';
import {processTranslation} from '../utils/commonUtil';

class PayoutDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }


    getCurrencyListItems = (currencyList) => {
        const {translations} = this.props;
        const items = currencyList && currencyList.length > 0 ?
            currencyList.map((e) => ({
                label: `${getCurrencySymbol(e)} (${translations[`ipmob.currency.${e}`] ? translations[`ipmob.currency.${e}`] : e})`,
                value: e
            })) :
            [];
        items.unshift('');
        return items;
    }

    getBankingCountryListItems = (bankingCountryList) => {
        const {translations} = this.props;
        const items = bankingCountryList && bankingCountryList.length > 0 ?
            bankingCountryList.map((e) => ({
                label: translations[`ipmob.brand_determination.country.${e.countryCode}`],
                value: e.countryCode
            })) : [];
        items.unshift('');
        return items;
    }

    getBankingStateListItems = (country) => {
        const regions = StabAddressFormConfigurator.getRegions(country);
        const bankingStateList = toArray(regions).map((entry) => {
            return {
                value: entry,
                label: entry
            };
        });

       return bankingStateList? [{value: '', label: ''}].concat(bankingStateList) : null;
    }

    renderCurrencyComponent = (currencyList) => {
        const {currency, translations, handleCurrencyChange, handleCurrencyOnBlur, currencyError} = this.props;
        const singleCurrencyText = `${getCurrencySymbol(currencyList[0])} (${translations[`ipmob.currency.${currencyList[0]}`] ? translations[`ipmob.currency.${currencyList[0]}`] : currencyList[0]})`;
        const currencyHead = currencyList.length === 1? processTranslation(translations['ipmob.payout_details.sub_heading_2.alt'], [singleCurrencyText]): translations['ipmob.payout_details.sub_heading_2'];
        return (<div>
                    <div className="wrapper">
                        <div className="content-col-text sub-head">
                            <h3>{currencyHead}</h3>
                        </div>
                    </div>
                    <div className="wrapper">
                        <div className="content-col">
                            {currencyList.length > 1 && <FormSelect
                                id="currencySelection"
                                name="Currency selected"
                                items={this.getCurrencyListItems(currencyList)}
                                label={translations['ipmob.currency']}
                                value={currency}
                                onChange={handleCurrencyChange}
                                errorMsg={translations[currencyError]}
                                onBlur={handleCurrencyOnBlur}
                                                        />
                            }
                        </div>
                    </div>
               </div>)
    }




    render() {
        const {
            translations,

            bankingCountryList,
            bankingCountryCode,
            bankingCountryCodeError,
            handleBankingCountryChange,
            handleBankingCountryOnBlur,

            showBankingState,
            bankingState,
            bankingStateError,
            handleBankingStateChange,
            handleBankingStateOnBlur,

            currencyList,

            serviceError,
            handleAlertDismiss,
            enableContinueButton,
            enableBackButton,
            handleFormSubmit,
            handleBackButtonClick,
        } = this.props;

        return (
            <div id="payout-details" className="payout-details">
                <div className="payout-details-container">
                        <div className="form-col">
                            {(serviceError) ? (
                                <div className="alert-panel">
                                    <AlertBox
                                        messageKey={serviceError}
                                        translations={translations}
                                        handleAlertDismiss={handleAlertDismiss}
                                        size={'sm'}
                                    />
                                </div>
                            ) : null}

                            <div className="wrapper">
                                <div className="content-col-text panel-head">
                                    <h1 className="head">{translations['ipmob.payout_details.heading_1']}</h1>
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="content-col-text head">
                                    <div className="desc">{translations['ipmob.payout_details.heading_1.desc']}</div>
                                </div>
                            </div>
                            <form role="form" onSubmit={handleFormSubmit}>
                                <div className="input-container" aria-label="Big form">
                                    <div className="wrapper">
                                        <div className="content-col-text sub-head">
                                            <h3>{translations['ipmob.payout_details.sub_heading_1']}</h3>
                                        </div>
                                    </div>
                                    <div className="wrapper">
                                        <div className="content-col-text">
                                            <div className="desc">{translations['ipmob.payout_details.sub_heading_1.desc']}</div>
                                        </div>
                                    </div>
                                    <div className="wrapper">
                                        <div className="content-col">
                                            <FormSelect
                                                id="bankingCountry"
                                                name="Banking Country selected"
                                                items={this.getBankingCountryListItems(bankingCountryList)}
                                                label={translations['ipmob.mailing_address.label_1']}
                                                value={bankingCountryCode}
                                                onChange={handleBankingCountryChange}
                                                errorMsg={translations[bankingCountryCodeError]}
                                                onBlur={handleBankingCountryOnBlur}
                                            />
                                        </div>
                                    </div>

                                    {showBankingState && <div className="wrapper">
                                        <div className="content-col">
                                            <FormSelect
                                                id="bankingState"
                                                name="Banking State selected"
                                                items={this.getBankingStateListItems(bankingCountryCode)}
                                                label={translations['ipmob.mailing_address.label_5']}
                                                value={bankingState}
                                                onChange={handleBankingStateChange}
                                                errorMsg={translations[bankingStateError]}
                                                onBlur={handleBankingStateOnBlur}
                                            />
                                        </div>
                                    </div>}
                                </div>
                                {currencyList && currencyList.length > 0
                                    ? this.renderCurrencyComponent(currencyList)
                                    : null
                                }
                                <ContinueButtonHolder
                                    enableContinueButton={enableContinueButton}
                                    handleContinueButtonClick={handleFormSubmit}
                                    translations={translations}
                                    enableBackButton={enableBackButton}
                                    handleBackButtonClick={handleBackButtonClick}
                                    continueButtonId={'payoutDetailsContinueBtn'}
                                />
                            </form>
                        </div>

                        <div className="spacer-col"/>

                        <div className="content-col info-card-col">
                            <InfoCard className="payout-details-info-card">
                                <h2 className="info-card-header">{translations['ipmob.payout_details.info.heading_1']}</h2>
                                <p className="info-card-text">{translations['ipmob.payout_details.info.heading_1.desc']}</p>
                            </InfoCard>
                        </div>
                </div>
            </div>
        );
    }
}

export default PayoutDetails;
